import React, { useState } from 'react';
import _ from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { motion } from 'framer-motion';
import BoxedContainer from './layouts/BoxedContainer';
import useMediaQuery from '../hooks/useMediaQuery';

function CentreItem({ data, index }) {
  const title = _.get(data, 'content.title', '');
  const text = _.get(data, 'content.text', '');
  const image = _.get(data, 'content.image', {});
  const listTitle = _.get(data, 'content.listTitle', '');
  const listCol1 = _.get(data, 'content.listCol1', []);
  const listCol2 = _.get(data, 'content.listCol2', []);
  const website = _.get(data, 'content.website', '');
  const tel = _.get(data, 'content.tel', '');
  const email = _.get(data, 'content.email', '');
  const [toggle, setToggle] = useState(false);
  const isDesktop = useMediaQuery('(min-width: 768px)');

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.3 * (index + 1), delay: 0.6 }}
      className="col-span-12 md:col-span-6 xl:col-span-4 
      flex flex-col border border-[#ccc] bg-white">
      {_.isEmpty(image) || (
        <LazyLoadImage
          src={image.url}
          alt={image.alt}
          effect="blur"
          wrapperClassName="aspect-[450/220] !block"
          className="w-full h-full object-cover"
        />
      )}
      <div
        className="w-full px-2.5 py-5 sm:p-5 xl:p-10 gap-2.5
      lg:gap-5 flex flex-col grow">
        {isDesktop ? (
          <h3
            className="text-clamp20to25 leading-1.5 m-0 text-[#58595B]
          !font-LibreBaskervilleRegular">
            {title}
          </h3>
        ) : (
          <button
            type="button"
            className="w-full flex justify-between items-center"
            onClick={() => setToggle(!toggle)}>
            <h3 className="text-[14px] leading-1.5 m-0 !font-LibreBaskervilleRegular">{title}</h3>
            {toggle ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="7"
                viewBox="0 0 12 7"
                fill="none">
                <path
                  d="M1 6L6 1L11 6"
                  stroke="#333333"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="7"
                viewBox="0 0 12 7"
                fill="none">
                <path
                  d="M11 1L6 6L1 1"
                  stroke="#333333"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
          </button>
        )}
        <div
          className="w-full flex flex-col gap-5 lg:gap-7.5 data-[toggle=false]:hidden"
          data-toggle={isDesktop || toggle}>
          <p className="text-clamp12to16 leading-1.5 m-0 ltr:font-URWDINRegular rtl:font-GESSTwoDWTCLight text-[#4A4A4A]">
            {text}
          </p>
          <div className="w-full flex flex-col gap-2 lg:gap-4">
            <h4
              className="m-0 text-clamp12to15 uppercase ltr:font-URWDINMedium rtl:font-GESSTwoDWTCLight
            text-[#333]">
              {listTitle}
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 md:gap-x-5">
              <ul className="flex flex-col grow gap-y-1.5 mb-1.5 md:mb-0">
                {_.map(listCol1, (point, key) => (
                  <li
                    key={key}
                    className="text-clamp12to16 before:inline before:content-['\2022']
                    relative ltr:pl-5 rtl:pr-5 before:leading-[0.7]
                    before:absolute before:ltr:left-0 before:rtl:right-0 before:top-[3px] md:before:top-[5px]
                    before:text-lg leading-[1.3] flex items-center text-[#000]
                    ltr:font-URWDINRegular rtl:font-GESSTwoDWTCLight">
                    {point}
                  </li>
                ))}
              </ul>
              <ul className="flex flex-col grow gap-y-1.5">
                {_.map(listCol2, (point, key) => (
                  <li
                    key={key}
                    className="text-clamp12to16 before:inline before:content-['\2022'] 
                    relative ltr:pl-5 rtl:pr-5 before:leading-[0.7]
                    before:absolute before:ltr:left-0 before:rtl:right-0 before:top-[3px] md:before:top-[5px]
                    before:text-lg leading-[1.3] flex items-center text-[#000]
                    ltr:font-URWDINRegular rtl:font-GESSTwoDWTCLight">
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div
        className="w-full p-5 xl:p-7.5 xl:px-10 gap-x-7.5 gap-y-2.5 flex flex-wrap
        data-[toggle=false]:hidden border-t"
        data-toggle={isDesktop || toggle}>
        {tel &&
          (tel.includes('<a href') ? (
            <div
              className="text-[#CE435B] text-[13px] 
            md:text-[15px] flex gap-2
            font-DINRegular whitespace-nowrap">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                className="min-w-[18px] top-[2px] relative">
                <g clipPath="url(#clip0_2370_28247)">
                  <path
                    d="M8.14162 10.2756C7.26412 9.39813 6.60262 8.41563 6.16312 7.41888C6.07012
                  7.20813 6.12487 6.96138 6.28762 6.79863L6.90187 6.18513C7.40512 5.68188 7.40512
                  4.97013 6.96562 4.53063L6.08512 3.65013C5.49937 3.06438 4.54987 3.06438 3.96412
                  3.65013L3.47512 4.13913C2.91937 4.69488 2.68762 5.49663 2.83762 6.29163C3.20812
                  8.25138 4.34662 10.3971 6.18337 12.2339C8.02012 14.0706 10.1659 15.2091 12.1256
                  15.5796C12.9206 15.7296 13.7224 15.4979 14.2781 14.9421L14.7664 14.4539C15.3521
                  13.8681 15.3521 12.9186 14.7664 12.3329L13.8866 11.4531C13.4471 11.0136 12.7346
                  11.0136 12.2959 11.4531L11.6186 12.1311C11.4559 12.2939 11.2091 12.3486 10.9984
                  12.2556C10.0016 11.8154 9.01912 11.1531 8.14162 10.2756Z"
                    stroke="#CE435B"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2370_28247">
                    <rect width="18" height="18" fill="white" transform="translate(0 0.417603)" />
                  </clipPath>
                </defs>
              </svg>
              <span dir="ltr"
                className="inline-block hover:[&>a]:underline [&>a]:text-[#CE435B] 
                [&>a]:inline-block"
                dangerouslySetInnerHTML={{ __html: tel }}
              />
            </div>
          ) : (
            <a
              href={`tel:${tel}`}
              className="text-[#CE435B] hover:underline text-[13px] 
            md:text-[15px] flex gap-2
            font-DINRegular">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                className="min-w-[18px] top-[2px] relative">
                <g clipPath="url(#clip0_2370_28247)">
                  <path
                    d="M8.14162 10.2756C7.26412 9.39813 6.60262 8.41563 6.16312 7.41888C6.07012
                  7.20813 6.12487 6.96138 6.28762 6.79863L6.90187 6.18513C7.40512 5.68188 7.40512
                  4.97013 6.96562 4.53063L6.08512 3.65013C5.49937 3.06438 4.54987 3.06438 3.96412
                  3.65013L3.47512 4.13913C2.91937 4.69488 2.68762 5.49663 2.83762 6.29163C3.20812
                  8.25138 4.34662 10.3971 6.18337 12.2339C8.02012 14.0706 10.1659 15.2091 12.1256
                  15.5796C12.9206 15.7296 13.7224 15.4979 14.2781 14.9421L14.7664 14.4539C15.3521
                  13.8681 15.3521 12.9186 14.7664 12.3329L13.8866 11.4531C13.4471 11.0136 12.7346
                  11.0136 12.2959 11.4531L11.6186 12.1311C11.4559 12.2939 11.2091 12.3486 10.9984
                  12.2556C10.0016 11.8154 9.01912 11.1531 8.14162 10.2756Z"
                    stroke="#CE435B"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2370_28247">
                    <rect width="18" height="18" fill="white" transform="translate(0 0.417603)" />
                  </clipPath>
                </defs>
              </svg>
              {tel}
            </a>
          ))}
        {email &&
          (email.includes('<a href') ? (
            <div
              className="text-[#CE435B] text-[13px] 
            md:text-[15px] flex gap-2
            font-DINRegular">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                className="min-w-[18px] top-[2px] relative">
                <g clipPath="url(#clip0_2370_28252)">
                  <path
                    d="M5.625 7.7301L7.8191 9.08283C8.17411 9.3017 8.58295 9.4176 9 9.4176C9.41705
                  9.4176 9.82589 9.3017 10.1809 9.08283L12.375 7.7301"
                    stroke="#CE435B"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M13.5 4.1676H4.5C3.25736 4.1676 2.25 5.17496 2.25 6.4176V12.4176C2.25 13.6602
                  3.25736 14.6676 4.5 14.6676H13.5C14.7426 14.6676 15.75 13.6602 15.75
                  12.4176V6.4176C15.75 5.17496 14.7426 4.1676 13.5 4.1676Z"
                    stroke="#CE435B"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2370_28252">
                    <rect width="18" height="18" fill="white" transform="translate(0 0.417603)" />
                  </clipPath>
                </defs>
              </svg>
              <span 
              className="hover:[&>a]:underline text-[#CE435B] [&>a]:text-[#CE435B]" 
              dangerouslySetInnerHTML={{ __html: email }} />
            </div>
          ) : (
            <a
              href={`mailto:${email}`}
              className="text-[#CE435B] hover:underline text-[13px] 
              md:text-[15px] flex items-center gap-2
            font-DINRegular">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none">
                <g clipPath="url(#clip0_2370_28252)">
                  <path
                    d="M5.625 7.7301L7.8191 9.08283C8.17411 9.3017 8.58295 9.4176 9 9.4176C9.41705
                  9.4176 9.82589 9.3017 10.1809 9.08283L12.375 7.7301"
                    stroke="#CE435B"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M13.5 4.1676H4.5C3.25736 4.1676 2.25 5.17496 2.25 6.4176V12.4176C2.25 13.6602
                  3.25736 14.6676 4.5 14.6676H13.5C14.7426 14.6676 15.75 13.6602 15.75
                  12.4176V6.4176C15.75 5.17496 14.7426 4.1676 13.5 4.1676Z"
                    stroke="#CE435B"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2370_28252">
                    <rect width="18" height="18" fill="white" transform="translate(0 0.417603)" />
                  </clipPath>
                </defs>
              </svg>
              {email}
            </a>
          ))}

        {website && (
          <a
            href={website}
            className="text-[#CE435B] hover:underline text-[13px] md:text-[15px] flex items-center gap-2
            font-DINRegular"
            target="_blank"
            rel="noreferrer">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="19"
              viewBox="0 0 18 19"
              fill="none">
              <g clipPath="url(#clip0_2370_28258)">
                <path
                  d="M9 2.6676C12.7365 2.6676 15.75 5.6811 15.75 9.4176C15.75 13.1541 12.7365
                  16.1676 9 16.1676"
                  stroke="#CE435B"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9 16.1676C5.2635 16.1676 2.25 13.1541 2.25 9.4176C2.25 5.6811 5.2635 2.6676 9
                  2.6676"
                  stroke="#CE435B"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M7.62563 3.46266C5.45812 7.08141 5.45812 11.7547 7.62563 15.3734C8.26013
                  16.4332 9.73987 16.4332 10.3744 15.3734C12.5419 11.7547 12.5419 7.08141 10.3744
                  3.46266C9.73912 2.40291 8.26013 2.40291 7.62563 3.46266Z"
                  stroke="#CE435B"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M2.25 9.4176H15.75"
                  stroke="#CE435B"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_2370_28258">
                  <rect width="18" height="18" fill="white" transform="translate(0 0.417603)" />
                </clipPath>
              </defs>
            </svg>
            {website.replace(/^(https?:\/\/)?(www\.)?/, '')}
          </a>
        )}
      </div>
    </motion.div>
  );
}

function FreeZoneBusinessCentreItems({ id, data }) {
  const listItems = _.get(data, 'listItems', []);

  return (
    <section id={id} className="relative bg-[#fafafa] md:bg-[#f7f7f7]">
      <BoxedContainer variant="lg">
        <div className="w-full grid grid-cols-12 gap-6 md:gap-8 xl:gap-10 pb-[50px] lg:pb-[100px]">
          {_.map(listItems, (item, key) => (
            <CentreItem index={key} data={item} />
          ))}
        </div>
      </BoxedContainer>
    </section>
  );
}

export default FreeZoneBusinessCentreItems;
